/**
 * Unicode and non-Latin character-aware base64 encoding helper.
 */
export function base64Encode(str: string): string {
  return btoa(unescape(encodeURIComponent(str)));
}
